export default __webpack_public_path__ + "static/media/12 NO PROBIHITED ITEMS SYMBOL.3f572f2b.png";